import {FBColumnOptions} from "FormBuilder/Core/FBColumn.Options";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBFieldBaseOptions} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBRow} from "FormBuilder/Core/FBRow";
import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FieldFactory} from "FormBuilder/FieldFactory";
import {ModelSerialize} from "FormBuilder/Core/Models/ModelBase";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";

declare let rednaoProductDesigner:any;

export class FBColumnModel extends ModelWithParent<FBColumnOptions,FBRowModel>{
    @ModelSerialize()
    public Field:FBFieldBaseModel;
    public Instance:HTMLDivElement;

    public get FormBuilder(){
        return this.Parent.Parent;
    }

    public get IsDesign(){
        return typeof rednaoProductDesigner!='undefined'&&rednaoProductDesigner.IsDesign=='1'

    }



    constructor(Options: FBColumnOptions, Parent: FBRowModel,previousData:any=null) {
        super(Options, Parent);
        this.Field = FieldFactory.GetFieldModel(this,Options.Field,previousData);
    }



}